import api from "../api/apiInstance";

export async function downloadFileFromStream(address: string, fileName: string): Promise<boolean> {
  try {
    const response = await api.get(address, {
      responseType: 'blob', // Use 'blob' instead of 'stream' for browser compatibility
    });

    // Create a URL for the blob
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Set the desired file name
    link.setAttribute('download', fileName);

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error('Error downloading file:', (error as any).message);
    return true;
  }
}